import { Component, EventEmitter, OnInit, Input, Output, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-notes',
  templateUrl: './Notes.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => NotesComponent)}]
})
export class NotesComponent extends BaseControlGroupComponent {

    @Input() public requireDispatchPlannerNotes: boolean;  
    @Input() public requireDriverNotes: boolean;
    @Input() public requireMasterDataNotes: boolean;
    @Input() public requireSurveyRequestDescription: boolean;
    @Input() public requireNotes: boolean;
  
    @Input() public showDispatchPlannerNotes: boolean;  
    @Input() public showDriverNotes: boolean;
    @Input() public showMasterDataNotes: boolean;
    @Input() public showSurveyRequestDescription: boolean;
    @Input() public showNotes: boolean;

    notesForm: FormGroup;
    otherInfo: ent.OtherInfo = new ent.OtherInfo();
    setDates(){}

    setRequestInfo(request: ent.Request){
        this.otherInfo = request.OtherInfo;
    }
    
    constructor(fb: FormBuilder) 
    { 
        super();  
        let group = {
          'dispatchPlannerNotes' : '',
          'driverNotes' : '',
          'requestorNotesToMasterData' : '',
          'surveyRequestDescription' : '',
          'notes' : ''
        };
        
        this.notesForm = fb.group(group);

    }


    ngOnInit(): void {
        if(this.requireDispatchPlannerNotes) {
          this.notesForm.controls['dispatchPlannerNotes'].setValidators(Validators.required);
        }

        if(this.requireDispatchPlannerNotes) {
          this.notesForm.controls['driverNotes'].setValidators(Validators.required);
        }

        if(this.requireMasterDataNotes) {
          this.notesForm.controls['requestorNotesToMasterData'].setValidators(Validators.required);
        }

        if(this.requireSurveyRequestDescription) {
          this.notesForm.controls['surveyRequestDescription'].setValidators(Validators.required);
        }

        if(this.requireNotes) {
          this.notesForm.controls['notes'].setValidators(Validators.required);
        }
    }

}